// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-management-objects-ManagementSpecCommon-AttrsListEditor-AttrsListEditor-module__box--ItGiv {
  display: flex;
  flex-direction: column;
}
.src-pages-management-objects-ManagementSpecCommon-AttrsListEditor-AttrsListEditor-module__header--XHL8I {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.src-pages-management-objects-ManagementSpecCommon-AttrsListEditor-AttrsListEditor-module__title--Pq_Il {
  flex: 1;
  font-weight: bold;
  font-size: 1.1;
}
/*# sourceMappingURL=AttrsListEditor.module.css.map */`, "",{"version":3,"sources":["webpack://./AttrsListEditor.module.less","webpack://./src/pages/management/objects/ManagementSpecCommon/AttrsListEditor/AttrsListEditor.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;ACCF;ADCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;ACCF;ADCA;EACE,OAAA;EACA,iBAAA;EACA,cAAA;ACCF;AACA,qDAAqD","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n}\n.header {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n}\n.title {\n  flex: 1;\n  font-weight: bold;\n  font-size: 1.1;\n}\n",".box {\n  display: flex;\n  flex-direction: column;\n}\n.header {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n}\n.title {\n  flex: 1;\n  font-weight: bold;\n  font-size: 1.1;\n}\n/*# sourceMappingURL=AttrsListEditor.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-pages-management-objects-ManagementSpecCommon-AttrsListEditor-AttrsListEditor-module__box--ItGiv`;
export var header = `src-pages-management-objects-ManagementSpecCommon-AttrsListEditor-AttrsListEditor-module__header--XHL8I`;
export var title = `src-pages-management-objects-ManagementSpecCommon-AttrsListEditor-AttrsListEditor-module__title--Pq_Il`;
export default ___CSS_LOADER_EXPORT___;
